import { createFileRoute } from "@tanstack/react-router";
import MembersSection from "@/features/settings/components/MembersSection";
import { useCurrentOrg, useIsOrgAdmin } from "@/stores";

function SettingsMembersRoute() {
  const org = useCurrentOrg();
  const canEdit = useIsOrgAdmin();
  if (!org) return null;
  return <MembersSection orgId={org.id} canEdit={canEdit} />;
}

export const Route = createFileRoute("/_admin/settings/members")({
  component: SettingsMembersRoute,
});
